import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { IChange } from '../shared/change';
import { CompareService } from '../compare/compare.service';
import { IProject } from '../shared/project';
import { IRepo } from '../shared/repo';
import { IBranch } from '../shared/branch';
import { IDbFormObj } from '../shared/IDbFormObj';
import * as auth from '../auth-config.json';
import { Account } from '../shared/account';

@Component({
  selector: 'app-db',
  templateUrl: './db.component.html',
  styleUrls: ['./db.component.css']
})
export class DbComponent implements OnInit {

  public changes: IChange[];
  constructor(private data: CompareService, private spinner: NgxSpinnerService, private router: Router,
    private fb: FormBuilder, private authService: MsalService, private msalBroadcastService: MsalBroadcastService) { }

  public compareForm: FormGroup;
  public projects: IProject[];
  public repos: IRepo[];
  public branches: IBranch[];
  public selectedProject: string;
  public selectedRepo: string;
  public branchStart: string;
  public branchEnd: string;
  public dbFormObjects: IDbFormObj[] = new Array();
  loginDisplay = false;
  public message: string = "You must login to view this page.";

  ngOnInit() {

    this.handleSecurity();

    this.loadProjectDropdown();

    this.compareForm = this.fb.group({
      ddlStart: [''],
      ddlEnd: ['']
    })
  }

  handleSecurity() {

    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result) {
          this.authService.instance.setActiveAccount(result.account);
          console.log(result);
        }
        // Sets login display when using redirects
        this.setLoginDisplay();
      },
      error: (error) => console.log(error)
    });

    // Sets login display when using popups
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {
    let allowedRoles = [auth.roles.BuildManager];

    let accounts: AccountInfo[] = this.authService.instance.getAllAccounts();
    let account: Account = accounts[0];

    this.loginDisplay = accounts.length > 0;

    if (this.loginDisplay && !allowedRoles.includes(account.idTokenClaims?.roles[0])) {
      this.loginDisplay = false;
      this.message = 'You do not have the correct permissions to view this page.';
    }
  }

  resetValues() {
    this.repos = null;
    this.selectedRepo = "";
    this.branchStart = null;
    this.branchEnd = null;
    this.branches = null;
  }

  cancel() {
    this.resetValues();
    if (this.selectedProject !== "") {
      this.selectedProject = "";
      this.projects = null;
      this.loadProjectDropdown();
    }
  }

  loadProjectDropdown() {
    this.data.loadProjects()
      .subscribe(data => {
        this.projects = data;
      });
  }

  getRepos(name: any) {
    if (name !== "0") {
      this.resetValues();
      this.selectedProject = name;
      this.data.getReposByProject(name)
        .subscribe(data => {
          this.repos = data;
        });
    }
  }


  getBuildBranches(repo: string) {
    if (repo !== "0") {
      this.selectedRepo = repo;
      this.data.getBranchesByRepo(this.selectedProject, repo)
        .subscribe(data => {
          this.branches = data;
        });
    }
  }

  removeCompare(startBranch: string) {
    this.dbFormObjects = this.dbFormObjects.filter((obj) => {
      return obj.startBranch !== startBranch;
    });
  }

  containsObject(obj: IDbFormObj, ary: IDbFormObj[]) {

    for (let i = 0; i < ary.length; i++) {
      if (ary[i].repositoryId === obj.repositoryId
        && ary[i].startBranch === obj.startBranch
        && ary[i].endBranch === obj.endBranch)
        return true;
    }
    return false;
  }

  addFormObject() {

    const repo = this.repos.find(r => r.id === this.selectedRepo);

    const compare: IDbFormObj =
    {
      projectName: this.selectedProject,
      repositoryId: this.selectedRepo,
      startBranch: this.branchStart,
      endBranch: this.branchEnd,
      repoName: repo.name
    };

    if (!this.containsObject(compare, this.dbFormObjects))
      this.dbFormObjects.push(compare);
  }

  setStartBranch(branch: string) {
    this.branchStart = this.branches.find(r => r.objectId === branch).name;
  }

  setEndBranch(branch: string) {
    this.branchEnd = this.branches.find(r => r.objectId === branch).name;
  }


  getDbScripts() {

    this.spinner.show();

    if (this.dbFormObjects !== null) {
      this.data.getChangesBetweenBuildsByRepoBatch(this.dbFormObjects)
        .subscribe(data => {
          this.changes = data;
          this.spinner.hide();
        });
    }
  }

}
